import { render, staticRenderFns } from "./order_result.vue?vue&type=template&id=10415fca&scoped=true&"
import script from "./order_result.vue?vue&type=script&lang=js&"
export * from "./order_result.vue?vue&type=script&lang=js&"
import style0 from "./order_result.vue?vue&type=style&index=0&id=10415fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10415fca",
  null
  
)

export default component.exports